import styled from 'styled-components';
import { DatePickerWrapperProps } from './type';

export const DatePickerWrapperStyled = styled.div<DatePickerWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  position: relative;
  width: ${({ dynamicWidth }) => dynamicWidth};
`;
